
const closeopen = {
  Sunday: {
    open: 10,
    opentomorrow: 8,
    close: 18
  },
  Monday: {
    open: 9,
    opentomorrow: 8,
    close: 20
  },
  Tuesday: {
    open: 9,
    opentomorrow: 8,
    close: 20
  },
  Wednesday: {
    open: 9,
    opentomorrow: 8,
    close: 20
  },
  Thursday: {
    open: 9,
    opentomorrow: 8,
    close: 20
  },
  Friday: {
    open: 9,
    opentomorrow: 8,
    close: 20
  },
  Saturday: {
    open: 9,
    opentomorrow: 10,
    close: 18
  }
}

export const getCloseOpenTimes = (_dow, _gpb, system) => {
  const _time = closeopen[_dow]

  // if its a group booking set the time to 18
  if (_gpb === '1') {
    _time.close = 18
  }
  // IE closes at 7pm not 8 like UK
  if (system === 'IE' && _time.close === 20) {
    _time.close = 19
  }

  return _time
}

export const getSystem = (arg) => {
  if (arg) {
    return arg.booking_site === 'com' ? 'UK' : 'IE'
  }
}

export const getUrl = (arg, bookingObj) => {
  let result = ''
  switch (arg) {
    case 'booking_conditions':
      result = `https://www.trailfinders.${bookingObj.booking_information.booking_site}/packagebookingconditions`
      break
    case 'insurance_quote':
      result = `https://www.trailfinders.${bookingObj.booking_information.booking_site}/insurance`
      break
  }
  return result
}

export const generateTCEmailAddress = (branchno) => {
  // Generate email address which alerts the travel centre.
  // Code nicked from the JSP page, so has lots of out-of-date Travel Centre codes...
  // But that is what is used by Superfacts, so have to keep them, eg LWW is still known as PIC (Picadilly).
  // default tc email address.
  let mailRcp = 'MANFP@trailfinders.com'
  switch (branchno) {
    case 'DUB':
      mailRcp = 'DUBFP@trailfinders.com'
      break
    case 'ORK':
      // handle SHS all are London Longhaul shops
      mailRcp = 'ORKFP@trailfinders.com'
      break
    case 'LMK':
      // handle ECR (Exxxxx or partition 1) bookings
      mailRcp = 'LMKFP@trailfinders.com'
      break
  }
  return mailRcp
}
